export default __webpack_public_path__ + "static/media/img-0403-austria-full-face.b12caf8a.png";